module.exports = __webpack_public_path__ + "static/img/registerBg3.5d375839.png";